<template>
   <div>
       <router-link :to="{ name: 'vehicle_fuel_consumption', query: { plateNumber: data.plateNumber }}" class="btn btn-success">{{data.fuelConsumedButton}}</router-link>
       <i class="fa-li fa fa-ellipsis-v dropbtn ml-2" @click="dropdownOption()"></i>
   </div>                             
</template>


<script>
import configObject from "@/config";
import Jquery from "jquery";
let $ = Jquery;

export default {
    data() {
        return {
        data: {},
        };
    },
    mounted() {
      window.onclick = (event) => {
            if (!event.target.matches('.dropbtn')) {
                  var dropdowns = document.getElementsByClassName("dropdown-content");
                  var i;
                  for (i = 0; i < dropdowns.length; i++) {
                        var openDropdown = dropdowns[i];
                        if (openDropdown.classList.contains('show')) {
                        openDropdown.classList.remove('show');
                        }
                  }
            }
      }
      
    },
    methods: {
        editVehicle(data) {
            this.$eventHub.$emit("setCustomerVehicle", data);
            
            this.$modal.show('editVehicle');
        },
        dropdownOption() {
            this.$eventHub.$emit('showExtraVehiclesOptions', this.data, this)
        },
    }
};
</script>